import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

export const lastOpenedBidByTenderAtom = atomWithStorage<Record<string, string>>(
  'lastOpenedBidByTender',
  {},
  undefined,
  { getOnInit: true },
);

export const createBidOpenAtom = atom(false);
